import React from "react";
import "./HomeStyle.css";
import Shikhaa_Logo from "../../Assets/Cover/Shikhaa_Logo.png";
import Shikha_Home from "../../Assets/Cover/Shikha_Home1.png";

function HomeItems() {
  return (
    <section className="my-5" id="home_section">
      <div>
        <div className="Shikha_logo">
          <img id="Shikha-logo" src={Shikhaa_Logo}></img>
        </div>
        {/* <h1 id="featured_Album">SHIKHAA - THE LIGHT</h1> */}
      </div>
      <div className="home_intro">
        <p>
          Shikhaa – The Light is a community-driven nonprofit organization
          (currently in the process of formal nonprofit registration) based in
          South Florida, dedicated to preserving and promoting Bangladeshi
          culture and heritage. The name “The Light” reflects the organization’s
          core mission—to spread the cultural light of education, awareness,
          ethics, morale values and identity among the Bangladeshi community,
          especially the younger generation growing up abroad.
        </p>
        <p>
          Through various social and cultural initiatives, Shikhaa – The Light
          brings families together and strengthens community bonds while
          celebrating shared traditions. One of its signature events is the
          annual Pitha Festival, a vibrant celebration of authentic Bangladeshi
          cuisine and heritage. The festival is accompanied by cultural
          activities such as music, recitation, and community-centered
          entertainment, creating a warm and engaging environment.
        </p>
        <p>
          Beyond celebration, the organization focuses on cultural
          education—helping Bangladeshi children in Florida connect with their
          roots, values, and identity. By acting as a guiding light, Shikhaa –
          The Light aims to keep the spirit of Bangladesh alive in the diaspora
          and inspire pride, awareness, and a deep sense of belonging for future
          generations.
        </p>
      </div>
      <div className="Shikha_Home">
        <img id="ShikhaHome" src={Shikha_Home} alt="Shikhaa Banner"></img>
      </div>
      <div className="home_intro">
        <p>
          শিখা – দ্য লাইট (Shikhaa – The Light) একটি কমিউনিটি-ভিত্তিক অলাভজনক
          প্রতিষ্ঠান (বর্তমানে নিবন্ধনের প্রক্রিয়ায় রয়েছে), যা দক্ষিণ
          ফ্লোরিডায় বসবাসরত বাংলাদেশি কমিউনিটির মধ্যে আমাদের সংস্কৃতি ও ঐতিহ্য
          সংরক্ষণ ও প্রসারে কাজ করছে। “The Light” নামটির মূল ভাবনা হলো—সংস্কৃতি,
          শিক্ষা ও সচেতনতার আলো ছড়িয়ে দিয়ে বাংলাদেশি কমিউনিটির মাঝে, বিশেষ
          করে প্রবাসে বেড়ে ওঠা নতুন প্রজন্মের মধ্যে তাদের পরিচয় ও শিকড়ের
          সঙ্গে সংযোগ স্থাপন করা।
        </p>
        <p>
          এই সংগঠনটি বিভিন্ন সামাজিক ও সাংস্কৃতিক কার্যক্রমের মাধ্যমে মানুষকে
          একত্রিত করে এবং পারস্পরিক বন্ধনকে আরও দৃঢ় করে তোলে। এর অন্যতম প্রধান
          আয়োজন হলো বার্ষিক পিঠা উৎসব, যেখানে ঐতিহ্যবাহী বাংলা পিঠার স্বাদ
          উপভোগের পাশাপাশি সংগীত, আবৃত্তি এবং নানা ধরনের বিনোদনমূলক কার্যক্রমের
          মাধ্যমে একটি প্রাণবন্ত পরিবেশ তৈরি করা হয়।
        </p>
        <p>
          শুধু উৎসব আয়োজনেই সীমাবদ্ধ না থেকে, শিখা – দ্য লাইট সাংস্কৃতিক
          শিক্ষার ওপর বিশেষ গুরুত্ব দেয়, যাতে ফ্লোরিডায় বেড়ে ওঠা বাংলাদেশি
          শিশু-কিশোররা তাদের শিকড়, মূল্যবোধ ও সাংস্কৃতিক পরিচয়ের সঙ্গে সংযুক্ত
          থাকতে পারে। একটি আলোর প্রদীপের মতো, এই সংগঠনটি প্রবাসে বাংলাদেশের
          সংস্কৃতির আলো জ্বালিয়ে রাখতে এবং আগামী প্রজন্মের মাঝে গর্ব, সচেতনতা ও
          আত্মপরিচয়ের বোধ জাগ্রত করতে নিরলসভাবে কাজ করে যাচ্ছে।
        </p>
      </div>
      {/* <div></div> */}
    </section>
  );
}

export default HomeItems;
